export class Logger {
    tag;
    #showDebug;
    constructor(tag, debugTag = tag) {
        this.tag = tag;
        const localStorage = 
        // @ts-ignore
        typeof window !== 'undefined' ? window.localStorage : undefined;
        this.#showDebug =
            localStorage?.getItem('DEBUG') === 'true' ||
                localStorage?.getItem('DEBUG')?.includes(debugTag);
    }
    info = (...args) => {
        console.log(`[${this.tag}]`, ...args);
    };
    warn = (...args) => {
        console.warn(`[${this.tag}]`, ...args);
    };
    urgent = (...args) => {
        console.error(`[${this.tag}]`, ...args);
    };
    fatal = (...args) => {
        console.error(`[${this.tag}]`, '<<FATAL>>', ...args);
    };
    debug = (...args) => {
        if (!this.#showDebug)
            return;
        console.debug(`[${this.tag}]`, ...args);
    };
}
export const logger = new Logger('general');
//# sourceMappingURL=logger.js.map